// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2Tn35","container":"footer-module--container--Mv3GA"};